import ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyRaw.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ResponseBody/ResponseBodyRaw.vue
var ResponseBodyRaw_default = ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBodyRaw_default as default };

//# sourceMappingURL=ResponseBodyRaw.vue.js.map